module.exports = (RESTService) ->
  'ngInject'
  RESTService.setFullResponse(true).service 'admin/notifications_campaigns'
